export default __webpack_public_path__ + "static/media/Shirt3.dc0f937b.jpeg";